import Storage from "../../services/localStorage";

export const types = {
  USER_INFO: 'USER_INFO',
  USER_LOGOUT: 'USER_LOGOUT'
}

export const userInfo = user => {
  if (user) {
    const { token, ...rest } = user;
    Storage.set('user', rest);
    Storage.set('token', token);
  }
  return (dispatch) => {
    dispatch({
      type: types.USER_INFO,
      payload: user || Storage.get('token') ? Storage.get('user') : null
    })
  }
}

export const logout = () =>{
  Storage.clear();
  return (dispatch)=>{
    dispatch({
      type: types.USER_LOGOUT
    })
  }
}